import React, {useState, useEffect} from "react";

import db from "../../../services/query";

import PrintTable from "../common/PrintTable";
import Img from "../../common/Img";
import AriaLogoNew from "../../../icons/aria-logo-new";


const StudentAttendance = (props) => {
    const { activeSem, studentId } = props.match.params;
    const [data, setData] = useState([]);

    const renderResult = (e) =>{
        let disqualified = e.attendance_result === 'disqualified';
        return (
            <div className={`result-result-${disqualified ? 3 : 1}`}>
                {disqualified ? 'محروم' : 'شامل امتحان'}
            </div>
        )
    }


    const columns = [
        { path: "id", label: "شماره" },
        { path: "subject_name", label: "مضمون", content: (e) => <b>{e.subject_name}</b> },
        { path: "credits", label: "تعداد کردت" },
        { path: "present_count", label: "حاضر", content: (e) => <div>{e.present_count} ({e.present_percentage}%)</div> },
        { path: "absent_count", label: "غیر حاضر", content: (e) => <div>{e.absent_count} ({e.absent_percentage}%)</div> },
        { path: "result", label: "نتیجه" , content: (e) => renderResult(e)},
    ];

    useEffect(() => {
        // to remove gradiant effect
        document.body.classList.add('no-linear-gradient');

        requestData();

        return () => setData([]);
    }, []);

    const requestData = async () => {
        let query = `results/students/${studentId}`;

        await db.getAll(query).then(({data}) => {
            setData(data);
            console.log(data)
        })
    }

    return (
        <main className="exam-result" style={{direction: "rtl"}}>
            {/* blue header */}
            <div className="exam-result-blue-header" >
                <div style={{float: "right", textAlign: "right", color: "white"}}>
                    <p style={{fontWeight: "bold"}}>پوهنتون آریا</p>
                    <p>{data?.data && data.data[activeSem]?.faculty_name}</p>
                    <p>{data?.data && data.data[activeSem]?.class_desc} ({data?.data && data.data[activeSem]?.time_name})</p>
                    <p>گزارش توحیدی حاضری محصل</p>
                </div>

                <div className='aria-logo' style={{float: "left", height: "150px", width: "100px" }}>
                    <AriaLogoNew />
                </div>

                <div style={{float: "left", textAlign: "left", color: "white"}}>
                    <h4 style={{fontWeight: "normal"}}>{/*پوهنتون آریا*/}</h4>
                    <h2 style={{fontWeight: "normal"}}></h2>
                </div>
            </div>

            <div className="main-print-wrapper" style={{paddingTop: "0",}}>
                {/* profile area */}
                <div className="exam-result-profile-area">
                    <div className="std-profile">
                        <div className="wrapper">
                            <Img src={data?.summary?.student_photo} border={true} />
                        </div>
                    </div>
                    <div className="overall-summary" style={{ height: "auto", minHeight: "100px", width: "360px" }}>
                        <div className="wrapper" style={{width: "100%", textAlign: "right", paddingRight: "5px"}}>
                            <h3 style={{fontWeight: "normal", textAlign: "right", margin: "0 0 4px"}}>{data?.data && data.data[activeSem]?.student_name}</h3>
                            <h5 style={{fontWeight: "normal", margin: "0 0 2px"}}>{data?.data && data.data[activeSem]?.student_father_name}</h5>
                            <h5 style={{fontWeight: "normal", margin: "0 0 2px", fontSize: "13px"}}>
                                کد دانشجویی: {(data?.summary?.aria_id || data?.data?.[activeSem]?.aria_id || '-')}
                            </h5>
                            <h5 style={{fontWeight: "normal", margin: 0, fontSize: "13px"}}>
                                کد صنف: {(data?.data?.[activeSem]?.class_id || '-')}
                                {data?.data?.[activeSem]?.class_desc ? ` — ${data.data[activeSem].class_desc}` : ''}
                            </h5>
                        </div>
                    </div>
                </div>

                {/* result table */}
                <PrintTable columns={columns} data={data?.data && data.data[activeSem]?.subjects}/>


                {/* summary area */}
                <div style={{ display: "grid",  gridTemplateColumns: "25% 25% 25% 25%" }}>
                        <div className="wrapper">
                            <p style={{color:"var(--font-color)"}}>مجموع کردت</p>
                            <h3 style={{color:"#004D98"}}>{data?.data && data.data[activeSem]?.subjects_summary?.credits || '-' }</h3>
                        </div>
                        <div className="wrapper">
                            <p style={{color:" var(--font-color)"}}>ساعات درسی</p>
                            <h3 style={{color:"#004D98"}}>{data?.data && data.data[activeSem]?.subjects_summary?.total_count || '-'}</h3>
                        </div>
                        <div className="wrapper">
                            <p style={{color:" var(--font-color)"}}>حاضر</p>
                            <h3 style={{color:"#004D98"}}>{data?.data && data.data[activeSem]?.subjects_summary?.present_count  || '-'}</h3>
                        </div>
                        <div className="wrapper">
                            <p style={{color:" var(--font-color)"}}>غیر حاضر</p>
                            <h3 style={{color:"#004D98"}}>{data?.data && data?.data[activeSem]?.subjects_summary?.absent_count  || '-'}</h3>
                        </div>
                    </div>
                </div>

                {/* signature area */}
                <div style={{
                    display: "grid",
                    gridTemplateColumns: "auto auto",
                    paddingTop: "50px",
                    textTransform: "uppercase"
                }}>
                    <div className="print-identity">
                        <div className="print-signature-area">
                            <div className="wrapper" style={{width: "70%"}}>
                                <hr/>
                                <p> امضاء مدیر تدریسی</p>
                            </div>
                        </div>
                    </div>
                    <div className="print-identity">
                        <div className="print-signature-area">
                            <div className="wrapper" style={{width: "70%"}}>
                                <hr/>
                                <p> امضاء رییس پوهنحی</p>
                            </div>
                        </div>
                    </div>
                </div>
        </main>
    );
};

export default StudentAttendance;
